/* This is generated code, don't alter */
var IfcStairFlightTypeEnum;
(function (IfcStairFlightTypeEnum) {
    IfcStairFlightTypeEnum[IfcStairFlightTypeEnum["STRAIGHT"] = 0] = "STRAIGHT";
    IfcStairFlightTypeEnum[IfcStairFlightTypeEnum["WINDER"] = 1] = "WINDER";
    IfcStairFlightTypeEnum[IfcStairFlightTypeEnum["SPIRAL"] = 2] = "SPIRAL";
    IfcStairFlightTypeEnum[IfcStairFlightTypeEnum["CURVED"] = 3] = "CURVED";
    IfcStairFlightTypeEnum[IfcStairFlightTypeEnum["FREEFORM"] = 4] = "FREEFORM";
    IfcStairFlightTypeEnum[IfcStairFlightTypeEnum["USERDEFINED"] = 5] = "USERDEFINED";
    IfcStairFlightTypeEnum[IfcStairFlightTypeEnum["NOTDEFINED"] = 6] = "NOTDEFINED";
})(IfcStairFlightTypeEnum || (IfcStairFlightTypeEnum = {}));
const IfcStairFlightTypeEnumCount = 7;
export { IfcStairFlightTypeEnum, IfcStairFlightTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcStairFlightTypeEnum = new Int32Array([721]);
let prefixSumAddressIfcStairFlightTypeEnum = new Uint32Array([0, 13, 21, 29, 39, 47, 59, 69]);
let slotMapIfcStairFlightTypeEnum = new Int32Array([5, 2, 1, 4, 3, 6, 0]);
let encodedDataIfcStairFlightTypeEnum = (new TextEncoder()).encode(".USERDEFINED..SPIRAL..WINDER..FREEFORM..CURVED..NOTDEFINED..STRAIGHT.");
let IfcStairFlightTypeEnumSearch = new MinimalPerfectHash(gMapIfcStairFlightTypeEnum, prefixSumAddressIfcStairFlightTypeEnum, slotMapIfcStairFlightTypeEnum, encodedDataIfcStairFlightTypeEnum);
export { IfcStairFlightTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcStairFlightTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcStairFlightTypeEnumSearch, input, cursor, endCursor);
}
